import { type Lap } from '../../domain/lap/Lap'
import { collectAndClassifyCoastingData } from './dataCollection'
import {
  removeAnomalies,
  fillCoastingGaps,
  removeIsolatedSpikes,
} from './anomalyRemoval'
import {
  applyFinalIntensitySmoothing,
  applyPostSmoothingCleanup,
} from './visualSmoothing'
import { applyTransitionInfluence } from './transitionDetection'
import { type CoastingPeriod, type CoastingConfig } from './types'
import type { VehicleStrategy } from './vehicles/VehicleStrategy'

export const executeCoastingPipeline = (
  selectedLaps: Lap[],
  config: CoastingConfig,
  vehicleStrategy: VehicleStrategy
): CoastingPeriod[] =>
  selectedLaps.flatMap((lap) => executeForLap(lap, config, vehicleStrategy))

const executeForLap = (
  lap: Lap,
  config: CoastingConfig,
  vehicleStrategy: VehicleStrategy
): CoastingPeriod[] => {
  const classifiedData = [
    ...collectAndClassifyCoastingData([lap], config, vehicleStrategy),
  ]
  const cleanedData = signalCleaning(classifiedData)
  const transitionAdjustedData = applyTransitionInfluence(
    cleanedData,
    vehicleStrategy
  )
  return applyVisualSmoothing(transitionAdjustedData)
}

const signalCleaning = (classifiedData: CoastingPeriod[]): CoastingPeriod[] => {
  const cleanedData = removeAnomalies(classifiedData)
  const gapFilledData = fillCoastingGaps(cleanedData)
  return removeIsolatedSpikes(gapFilledData)
}

const applyVisualSmoothing = (
  transitionAdjustedData: CoastingPeriod[]
): CoastingPeriod[] => {
  const smoothedIntensityData = applyFinalIntensitySmoothing(
    transitionAdjustedData
  )
  return applyPostSmoothingCleanup(smoothedIntensityData)
}
